import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'sd-chip',
  standalone: false,
  templateUrl: './chip.component.html',
  styleUrl: './chip.component.scss'
})
export class ChipComponent {
  @Input() removable = false;
  @Input() interactive = true;
  @Output() remove = new EventEmitter<void>();
}
